var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.946289C3.61758 0.946289 0.875 3.68887 0.875 7.07129C0.875 10.4537 3.61758 13.1963 7 13.1963C10.3824 13.1963 13.125 10.4537 13.125 7.07129C13.125 3.68887 10.3824 0.946289 7 0.946289ZM6.5625 4.11816C6.5625 4.05801 6.61172 4.00879 6.67188 4.00879H7.32812C7.38828 4.00879 7.4375 4.05801 7.4375 4.11816V7.83691C7.4375 7.89707 7.38828 7.94629 7.32812 7.94629H6.67188C6.61172 7.94629 6.5625 7.89707 6.5625 7.83691V4.11816ZM7 10.1338C6.82827 10.1303 6.66476 10.0596 6.54455 9.93691C6.42434 9.81423 6.35701 9.6493 6.35701 9.47754C6.35701 9.30577 6.42434 9.14085 6.54455 9.01816C6.66476 8.89548 6.82827 8.82479 7 8.82129C7.17173 8.82479 7.33524 8.89548 7.45545 9.01816C7.57566 9.14085 7.64299 9.30577 7.64299 9.47754C7.64299 9.6493 7.57566 9.81423 7.45545 9.93691C7.33524 10.0596 7.17173 10.1303 7 10.1338Z",
    fill: "#FA8C16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8aa81737c9f4c5bf89068c346a645487.svg";
export { ForwardRef as ReactComponent };